/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CustomizationDeliveryRestaurantQueryVariables = Types.Exact<{
  input: Types.LocationByAddressInput;
}>;

export type CustomizationDeliveryRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly slug: string;
          readonly deliveryFee: number;
        };
        readonly vendor: {
          readonly __typename?: 'Vendor';
          readonly name: string;
          readonly restaurantId: string;
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export const CustomizationDeliveryRestaurantDocument = gql`
  query CustomizationDeliveryRestaurant($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          __typename
          id
          slug
          deliveryFee
        }
        vendor {
          name
          restaurantId
        }
      }
    }
  }
`;

export function useCustomizationDeliveryRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<CustomizationDeliveryRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    CustomizationDeliveryRestaurantQuery,
    CustomizationDeliveryRestaurantQueryVariables
  >({ query: CustomizationDeliveryRestaurantDocument, ...options });
}
